const baseImgProduct = '/images/introduction/products'
const baseImgService = '/images/introduction/services'

export const products = [
	{
    img: `${baseImgProduct}/Dau_tu.jpg`,
		title: 'Đầu tư',
		content: `Xóa bỏ những lo âu trong cuộc sống, đạt được những mục tiêu trong tương lai, hơn thế nữa, bạn và gia đình luôn được bảo vệ tài chính trước những rủi ro bất ngờ....`,
		link: 'https://baovietnhantho.com.vn/san-pham/dau-tu-2',
	},
	{
    img: `${baseImgProduct}/Tich_luy.jpg`,
		title: 'Tích lũy',
		content: `Hiện thực hóa ước mơ về một cuộc sống bình an, gia đình hạnh phúc luôn là niềm trăn trở của bạn? Hãy cùng chúng tôi hoạch định cuộc sống hôm nay và cho cả ngày mai...`,
		link: 'https://baovietnhantho.com.vn/san-pham/tich-luy-3',
	},
	{
    img: `${baseImgProduct}/bao_ve.jpg`,
		title: 'Bảo vệ',
		content: 'Trước những rủi ro và biến động của cuộc sống, hãy chuẩn bị cho bản thân và gia đình thân thương những giải pháp tài chính an toàn nhất...',
		link: 'https://baovietnhantho.com.vn/san-pham/bao-ve-4',
	},
	{
    img: `${baseImgProduct}/huu_tri.jpg`,
		title: 'Hưu trí',
		content: 'Tạo dựng quỹ hưu trí bền vững để đảm bảo cuộc sống an nhàn khi về hưu luôn là một trong những mối quan tâm hàng đầu của người lao động...',
		link: 'https://baovietnhantho.com.vn/san-pham/Huu-tri-23',
	},
	{
    img: `${baseImgProduct}/Danh_cho_doanh_nghiep.jpg`,
		title: 'Doanh nghiệp',
		content: 'Xóa bỏ những lo âu trong cuộc sống, đạt được những mục tiêu trong tương lai, hơn thế nữa, bạn và gia đình luôn được bảo vệ tài chính trước những rủi ro bất ngờ...',
		link: 'https://baovietnhantho.com.vn/san-pham/danh-cho-doanh-nghiep-5',
	},
];

const services = [
	{
    img: `${baseImgService}/Kenh_thanh_toan.jpg`,
		title: 'Kênh đóng phí bảo hiểm',
		content: `Các hình thức nộp phí bảo hiểm và một số lưu ý khi nộp phí:`,
		link: 'https://www.baovietnhantho.com.vn/dich-vu-khach-hang#kenh-dong-phi-bao-hiem',
	},
	{
    img: `${baseImgService}/Thay_doi_thong_tin_HDBH.jpg`,
		title: 'Thay đổi thông tin HĐBH',
		content: `Để thay đổi các thông tin cá nhân trong hợp đồng bảo hiểm, Quý khách vui lòng điền vào Biểu mẫu thay đổi thông tin khách hàng...`,
		link: 'https://baovietnhantho.com.vn/dich-vu/Thay-doi-thong-tin-hop-dong-bao-hiem-3',
	},
	{
    img: `${baseImgService}/giai_quyet_QLBH.jpg`,
		title: 'Giải quyết quyền lợi BH',
		content: `Hồ sơ yêu cầu giải quyết quyền lợi bảo hiểm hợp lệ là: Các thông tin trên Giấy yêu cầu giải quyết quyền lợi bảo hiểm được kê khai đầy đủ, chính xác và trung thực...`,
		link: 'https://baovietnhantho.com.vn/dich-vu/Giai-quyet-quyen-loi-bao-hiem-4',
	},
	{
    img: `${baseImgService}/cam_nang_tham_gia_BHNT.jpg`,
		title: 'Cẩm nang tham gia BH',
		content: `Với mong muốn hỗ trợ Quý khách nắm bắt được những thông tin quan trọng và cơ bản khi tham gia bảo hiểm nhân thọ tại Bảo Việt, Bảo Việt Nhân thọ...`,
		link: 'https://www.baovietnhantho.com.vn/dich-vu-khach-hang#nhung-cau-hoi-thuong-gap',
	},
	{
    img: `${baseImgService}/cham_soc_KH.jpg`,
		title: 'Quà tặng bảo Việt Loyalty',
		content: `Với phương châm "Niềm tin vững chắc, cam kết vững bền",
		Bảo Việt Nhân thọ luôn chú trọng nâng cao chất lượng dịch vụ nhằm mang đến sự hài lòng cho khách hàng...`,
		link: 'https://www.baovietnhantho.com.vn/dich-vu-khach-hang#baoviet-loyalty',
	},
	{
    img: `${baseImgService}/CTKM.jpg`,
		title: 'Chương trình khuyến mại',
		content: `Các chương trình khuyến mại của Bảo Việt Nhân thọ`,
		link: 'https://www.baovietnhantho.com.vn/dich-vu-khach-hang#chuong-trinh-khuyen-mai',
	},
]

export default {
  products,
  services
}
